import React from "react";
import { ROUTE_KEYS, ROUTE_META, providerLabel } from "./aiRoutes";

/**
 * Safe / Explicit content mode switch with the active model for that mode.
 * The chosen mode is always sent explicitly by the caller; nothing defaults to explicit.
 */
export default function AIModeSelector({ mode, onChange, settings, disabled = false }) {
  const cfg = settings?.routes?.[mode];
  const status = settings?.provider_status?.find((provider) => provider.provider === cfg?.provider);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div role="radiogroup" aria-label="Content mode" className="inline-flex rounded-lg border border-zinc-700 bg-zinc-950 p-0.5">
        {ROUTE_KEYS.map((key) => {
          const active = mode === key;
          const activeClass =
            key === "explicit" ? "bg-rose-600 text-white" : "bg-emerald-600 text-white";
          return (
            <button
              key={key}
              type="button"
              role="radio"
              aria-checked={active}
              disabled={disabled}
              onClick={() => onChange(key)}
              title={`${ROUTE_META[key].title}: ${ROUTE_META[key].platforms}`}
              className={`px-3 py-1 rounded-md text-xs font-semibold transition disabled:opacity-50 ${
                active ? activeClass : "text-zinc-400 hover:text-zinc-200"
              }`}
            >
              {ROUTE_META[key].label}
            </button>
          );
        })}
      </div>
      <span className="text-[11px] text-zinc-400">
        {cfg ? (
          <>
            Model: <span className="text-zinc-200">{providerLabel(settings, cfg.provider)} · {cfg.model}</span>
            {status && !status.configured && <span className="ml-2 text-amber-400">{status.env_key} not set</span>}
          </>
        ) : (
          "Loading model…"
        )}
      </span>
    </div>
  );
}
